/* Generated by scripts/gen-app-segments.mjs before every build; do not edit. */
export const APP_SEGMENTS: readonly string[] = [
  "admin",
  "api",
  "apply",
  "approach",
  "auth",
  "blog",
  "case-study",
  "checkout",
  "command-center",
  "contact",
  "customers",
  "dashboard",
  "events",
  "expert",
  "for-you",
  "for-your-organization",
  "human-skills-map",
  "instructor",
  "invite",
  "join",
  "llms.txt",
  "login",
  "manifesto",
  "masterclass",
  "our-why",
  "portal",
  "pricing",
  "privacy",
  "process",
  "project-manager",
  "purpose",
  "reality-gap",
  "reset-password",
  "results",
  "services",
  "signup",
  "sms-terms",
  "solutions",
  "style-guide",
  "style-test",
  "talent",
  "team",
  "terms",
  "test-call",
  "test-images",
  "test-sentry",
  "test-seo",
  "trust",
  "unlock",
  "update-password",
  "why-we-exist",
  "workshops"
]
